@layer components {
  .frame {
    display: grid;
    grid-template-columns: minmax(0, 34rem);
    justify-content: center;
    padding-block: clamp(var(--space-6), 8vh, var(--space-12));
  }

  .panel {
    container-type: inline-size;
    display: grid;
    justify-items: center;
    gap: var(--space-3);
    padding: clamp(var(--space-8), 6vi, var(--space-12)) clamp(var(--space-5), 6vi, var(--space-10));
    text-align: center;
  }

  .icon {
    display: grid;
    place-items: center;
    inline-size: 4.5rem;
    block-size: 4.5rem;
    margin-block-end: var(--space-3);
    border-radius: var(--radius-blob);
    background: var(--color-accent-soft);
    color: var(--color-accent);
    rotate: -6deg;
    animation: blob-in var(--duration-spring) var(--ease-spring);

    & svg {
      inline-size: 2.125rem;
      block-size: 2.125rem;
      stroke-width: 2.1;
    }

    .panel[data-tone="danger"] & {
      background: var(--color-danger-soft);
      color: var(--color-danger);
    }
  }

  @keyframes blob-in {
    from {
      scale: 0.5;
      rotate: 12deg;
    }
  }

  .title {
    font-family: var(--font-display);
    font-size: clamp(var(--text-xl), 1.2rem + 1.2cqi, 2rem);
    font-weight: 700;
    line-height: 1.15;
    overflow-wrap: anywhere;
    text-wrap: balance;
  }

  .detail {
    color: var(--color-text-muted);
    line-height: 1.5;
    overflow-wrap: anywhere;
    text-wrap: pretty;
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    justify-self: stretch;
    gap: var(--space-2);
    margin-block-start: var(--space-4);

    @container (inline-size < 28rem) {
      & > * {
        flex: 1 1 8rem;
      }
    }
  }
}
